var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMinYMid meet",
    viewBox: "0 0 48 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mastercard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 48,
    height: 30,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,13.2453 C4.82892497,11.7791839 6,9.5263261 6,6.99995 C6,4.4735739 4.82892497,2.22071611 3,0.7546 C1.17107503,2.22071611 0,4.4735739 0,6.99995 C0,9.5263261 1.17107503,11.7791839 3,13.2453 L3,13.2453 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1-Copy-51"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#C5C5C8",
    strokeWidth: 1,
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 29,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1",
    fill: "#E41B24",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1-Copy",
    fill: "#F89E1B",
    cx: 18,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F16522",
    xlinkHref: "#path-2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.57e5b3fdf74d78e505499b005a7e2c73.svg";
export { ForwardRef as ReactComponent };